module.exports = __webpack_public_path__ + "stack-location.svg";